import { Injectable } from '@angular/core';
import {
    HttpInterceptor, HttpRequest, HttpHeaders,
    HttpHandler, HttpEvent, HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AlertSharedService } from '../_services';
import { AppComponent,changedHTTPRequest } from '../app.component';
const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
    })
};

@Injectable({
    providedIn: 'root'
})

export class InterceptorService implements HttpInterceptor {
    constructor(private alertSharedService: AlertSharedService) { }
    handleError(error: HttpErrorResponse) {
        if (error.message.indexOf("reload")<=0) //no need to check on get methods
        {
            console.log("HttpErrorResponse");
            console.log("error :" + error.message);
            var ShareHTTPRequestDetails = {
                "IsError": 1
            };
            changedHTTPRequest(ShareHTTPRequestDetails);
            return throwError(error);
        }
    }
    intercept(req: HttpRequest<any>, next: HttpHandler):
        Observable<HttpEvent<any>> {
        const clonedReq = req.clone({headers: req.headers.set('Content-Type', 'application/json').set('Access-Control-Allow-Origin', '*')});
        return next.handle(clonedReq)
            .pipe(
                catchError(this.handleError)
            )
    };
}